import _mixin from '../_mixin'
export default {
  name: 'SActivityRecord',
  cnName: '活动-记录按钮类',
  type: 'activity_common',
  preview: 'https://rescdn-crash.ssjj.cn/website/2023/03/30/dc3e42f445c1787417e8e090fd2b9591.jpeg',
  // 属性相关
  props: {
    activityId: 'ZHZTEJDNPJUGSO7W3SPOOLG6EY',
    defaultBg: {
      src: '',
      style: {
        width: '156px',
        height: '40px'
      }
    },
    btnRecord: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/03/12/6cddc2f7d4bd42cf5b034ea4be3d09af.png',
      style: {
        width: '156px',
        height: '40px',
        position: 'absolute',
        top: '0',
        right: '',
        bottom: '',
        left: '0'
      }
    },
    needAddress: false,
    // 抽奖活动id,即填写地址的id
    lotteryActivityId: 'ZHZTEJDNPJUGSO7W3SPOOLG6EY'
  },
  propsDesc: [
    {
      target: 'activityId',
      label: '记录活动Id'
    },
    {
      target: 'defaultBg',
      label: '底图',
      formType: 'image'
    },
    {
      target: 'btnRecord',
      label: '规则按钮图片',
      formType: 'image'
    },
    {
      target: '-----如果是抽奖类活动的领取记录，且需要填写地址，则需要填写以下信息，不然后期导出地址需要手动导出---  start--',
      formType: 'divider'
    },
    {
      target: 'needAddress',
      label: '是否需要填写地址',
      formType: 'switch'
    },
    {
      target: 'lotteryActivityId',
      label: '抽奖活动Id'
    },
    {
      target: '-----如果是抽奖类活动的领取记录，且需要填写地址，则需要填写以下信息，不然后期导出地址需要手动导出---  end--',
      formType: 'divider'
    }
  ],

  // 样式相关
  styles: {
    ..._mixin.styles
  },
  stylesDesc: [
    ..._mixin.stylesDesc
  ],

  // 事件相关
  events: {
    // click: () => {} 无需配置
  },
  eventsList: [
    // eventTpl 无需配置
  ],
  eventsDesc: [
    ..._mixin.eventsDesc
  ],

  methods: [
    ..._mixin.methods
  ]
}
